import { Stack, type StackProps, useTheme } from "@mui/material";
import { User } from "lucide-react";
import type { FC } from "react";

type Props = Omit<StackProps, "children"> & {
	name: string;
	photo?: string;
};

export const ProfileAvatar: FC<Props> = ({
	name,
	photo,
	sx,
	...stackProps
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			{...stackProps}
			sx={[
				{
					width: 80,
					height: 80,
					borderRadius: "50%",
					overflow: "hidden",
					background: theme.gradients.avatar,
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
		>
			{photo ? (
				<img
					src={photo}
					alt={name}
					width={80}
					height={80}
					style={{ objectFit: "cover" }}
				/>
			) : (
				<User size={40} color={theme.palette.darkmodeText.white} />
			)}
		</Stack>
	);
};
